(function () {
  'use strict';

  angular
    .module('web2print.whereTo', []);
})();
